module.exports = __webpack_public_path__ + "img/服务案例_节能_白2.3becef11.svg";